// extracted by mini-css-extract-plugin
export var base = "_3p-0";
export var updateBanner = "_3p-1";